module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-413.7de1b84.woff2";